<div [ngClass]="commonService.isHidden ?'':'container-fluid'">
    <div class="card-block" style="margin-left: 20px; margin-right: -12px;">
        <div class="head-block-title">
            <div class="row">
                <div class="col-md-8">
                    <span class="listHeaderText">Booking Pending Cancellations ({{bookingListData?.length}})</span>
                </div>
                <div class="col-md-4 d-flex" style="justify-content: flex-end;">
                    <export [showIconOnly]="false" [data]="selectedExportData"></export>
                </div>

            </div>
        </div>
        <div class="main-field">
            <div class="main-block-content">
                <div class="table-container">
                    <app-common-table-dark [columnDefs]="columnDefs" [data]="bookingListData" [rowStyles]="rowStyles"
                        [enableRowStyles]="true" (commonDropdownChange)="onCommonTableDropdownChange($event)"
                        (selectedRowsChange)="onSelectedRowsChange($event)">
                    </app-common-table-dark>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Cancellation Approval/rejection Modal -->
<p-dialog [(visible)]="showBookingCancellationDialogue" [modal]="true" [style]="{width: '350px'}" [styleClass]="'dark-dialog'">
    <p-header>Cancellation Details (#{{ cancelledRowData?.id }})</p-header>
    <p-body class="p-2 text-center">
        <div class="row">
            <div class="col-md-12 text-left">
                <label for="cancellationDate"><b>{{bookingApprovalRejection ? 'Approval': 'Rejection' }}
                        Date:</b></label>
                <p-calendar [(ngModel)]="bookingCancellationApprovalDate" dateFormat="dd/mm/yy" [maxDate]="maxDate"
                    appendTo="body" [showIcon]="true" inputId="buttondisplay" [showOnFocus]="false"
                    class="custom-calendar" />
            </div>
            <div class="col-md-12 text-left">
                <label for="cancellationReason"><b>{{ bookingApprovalRejection ? 'Approval': 'Rejection'}}
                        Reason:</b></label>
                <textarea id="approvalRejectionReason" [(ngModel)]="approvalRejectionReason" rows="4"
                    class="form-control"
                    placeholder="Enter {{ bookingApprovalRejection ? 'Approval': 'Rejection'}} reason here..."></textarea>
            </div>
            <div class="col-md-12 text-right mt-3">
                <button pButton type="button" label="Confirm" icon="pi pi-check" class="btn btn-primary"
                    (click)="submitCancellationStatus()" [disabled]="approvalRejectionReason?.length==0"></button>
                &nbsp;
                <button pButton type="button" label="Close" icon="pi pi-times" class="btn btn-secondary"
                    (click)="showBookingCancellationDialogue = false; approvalRejectionReason = '';"></button>
            </div>
        </div>
    </p-body>
</p-dialog>

<!-- Edit Cancellation Request Modal -->
<app-booking-cancellation-modal [isVisible]="showEditCancellationModal" [mode]="editModalMode"
    [bookingData]="cancelledRowData" [cancellationData]="cancelledRowData" (closeModal)="onEditCancellationModalClose()"
    (successfulSubmit)="onEditCancellationFormSubmit($event)">
</app-booking-cancellation-modal>
